import * as actionTypes from '../actions/actionTypes';

const initialState = {
    commission: null,
    error: false,
    loading: false,
    plan: null,
    total: null
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_COMMISSION:
            return {
                ...state,
                commission: action.commission,
                error: false,
                loading: false
            };
        case actionTypes.SET_COMMISSION_PLAN:
            return {
                ...state,
                plan: action.plan,
                error: false,
                loading: false
            };
        case actionTypes.SET_COMMISSION_PERFORMANCE:
            return {
                ...state,
                total: action.total,
                error: false,
                loading: false
            };
        case actionTypes.FETCH_COMMISSION_FAILED:
            return {
                ...state,
                error: action.error,
                loading: false
            };
        case actionTypes.FETCH_COMMISSION_STARTING:
            return {
                ...state,
                loading: true
            };
        default:
            return state;
    }
};

export default reducer;